import { z } from 'zod';
import { IdSchema } from './common.js';
/**
 * One assignment policy for inspections, tasks, and milestones (specification 6.3): exactly
 * one accountable owner and zero or more collaborators. Separate tables keep real foreign
 * keys; this contract keeps one behavior.
 */
export const AssignmentRoleSchema = z.enum(['owner', 'collaborator']);
export const AssignmentSchema = z.strictObject({
    membershipId: IdSchema,
    role: AssignmentRoleSchema,
});
export const AssignmentsSchema = z.strictObject({
    owner: IdSchema.nullable(),
    collaborators: z.array(IdSchema),
});
export const SetAssignmentsRequestSchema = z
    .strictObject({
    owner: IdSchema.nullable(),
    collaborators: z.array(IdSchema).max(20).default([]),
})
    .refine((value) => !value.owner || !value.collaborators.includes(value.owner), {
    message: 'The owner cannot also be a collaborator',
    path: ['collaborators'],
})
    .refine((value) => new Set(value.collaborators).size === value.collaborators.length, {
    message: 'Collaborators must be unique',
    path: ['collaborators'],
});
